<template>
  <v-row dense>
    <v-col cols="12">
      <v-card
        elevation="0"
        class="all-trade-tab rounded-0"
        :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'"
      >
        <v-tabs
          v-model="model"
          :background-color="$vuetify.theme.dark ? 'blue-darken-2' : 'white-lighten-2'"
        >
          <!-- INVESTOR WALLET -->
          <v-tab
            class="ml-0"
            v-if="hasInvestorWalletAccess"
            :href="`#tab-1`"
          >
            Investor Wallet
          </v-tab>

          <!-- MANAGER WALLET -->
          <v-tab
            v-if="hasManagerWalletAccess"
            :href="`#tab-2`"
          >
            Manager Wallet
          </v-tab>

          <!-- TAB CONTENT -->
          <v-tabs-items v-model="model">
            <v-tab-item :value="`tab-1`">
              <v-card flat>
                <InvestorWalletInfoTab />
              </v-card>
            </v-tab-item>

            <v-tab-item :value="`tab-2`">
              <v-card flat>
                <WalletInfoTab />
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import InvestorWalletInfoTab from "@/components/MamWallet/InvestorWalletInfoTab.vue";
import WalletInfoTab from "@/components/MamWallet/WalletInfoTab.vue";

export default {
  name: "WalletTabs",

  data() {
    return {
      tab: null,
      model: "tab-1", // default tab
    };
  },

  components: {
    InvestorWalletInfoTab,
    WalletInfoTab,
  },

  computed: {
    hasInvestorWalletAccess() {
      return this.$canRoute("investor-wallet") > 0;
    },
    hasManagerWalletAccess() {
      return this.$canRoute("manager-wallet") > 0;
    },
  },
};
</script>

<style scoped>
/* optional – keep empty to match your trx tabs */
</style>
